import _ from 'lodash';
import moment from 'moment';

import { db } from '../utils/configureFirebase';

export const getGDGroups = (cb) => {
  const query = db.collection('gdGroups');

  const unsubscribe = query.onSnapshot((snapshot) => {
    const groups = [];
    snapshot.forEach((doc) => {
      const groupData = doc.data();
      groups.push(groupData);
    });
    cb(groups);
  });

  return unsubscribe;
};

const generateGroupDiscussionID = async (jypCity) => {
  try {
    const groupDiscussionCountRef = db.collection('citiesGroupDiscussionCount').doc(jypCity);
    const groupDiscussionCountSnapshot = await groupDiscussionCountRef.get();
    const { count: prevCount } = groupDiscussionCountSnapshot.data();
    const count = prevCount + 1;
    await groupDiscussionCountRef.update({
      count,
    });

    return `JYP-GD-${jypCity.substring(0, 3)}-2018-${count}`;
  } catch (error) {
    return null;
  }
};

const getEligibleUsers = async () => {
  const users = [];
  try {
    const usersSnapshot = await db.collection('users').get();
    usersSnapshot.forEach((user) => {
      const userData = user.data();
      if (userData.type === 'ADMIN') {
        users.push({
          value: userData.id,
          label: userData.name,
        });
      }
    });
    return users;
  } catch (error) {
    return users;
  }
};
export const createGroups = async ({
  jypCity, groupSize, panelist1, panelist2,
}) => {
  const eligibleUsers = await getEligibleUsers();

  if (!_.find(eligibleUsers, { value: panelist1 })) {
    throw new Error({
      success: false,
      data: {
        errors: {
          panelist1: 'Panelist cannot conduct GD',
        },
      },
    });
  }

  if (!_.find(eligibleUsers, { value: panelist2 })) {
    throw new Error({
      success: false,
      data: {
        errors: {
          panelist2: 'Panelist cannot conduct GD',
        },
      },
    });
  }

  const gdGroupsCreated = [];
  const gdGroupsCreatedSnapshot = await db
    .collection('gdGroups')
    .where('jypCity', '==', jypCity)
    .get();
  gdGroupsCreatedSnapshot.forEach((group) => {
    gdGroupsCreated.push(group.data());
  });

  const candidatesList = [];
  const candidatesSnapshot = await db
    .collection('candidates')
    .where('stagesSelected.groupDiscussion', '==', true)
    .where('jypCity', '==', jypCity)
    .get();
  candidatesSnapshot.forEach((candidate) => {
    const { id: candidateId } = candidate.data();
    let isCandidateGrouped = false;
    gdGroupsCreated.forEach((group) => {
      // ensuring that once we change the flag to true, we
      // don't check in any other group
      if (!isCandidateGrouped) {
        if (_.includes(group.candidates, candidateId)) {
          isCandidateGrouped = true;
        }
      }
    });
    if (!isCandidateGrouped) {
      candidatesList.push(candidateId);
    }
  });

  if (candidatesList.length > 0) {
    // shuffle candidates list
    const candidatesListShuffled = _.shuffle(candidatesList);

    const groups = _.chunk(candidatesListShuffled, groupSize);

    if (groups.length >= 2) {
      // check for uneven grouping
      const lastGroup = groups[groups.length - 1];
      const lastButOneGroup = groups[groups.length - 2];
      if (lastGroup.length !== lastButOneGroup.length) {
        // if there is unevent grouping, merge the last two groups
        // and try to split the candidates evenly between them
        const lastGroupsSize = _.round(_.mean([lastGroup.length, lastButOneGroup.length]));
        const lastCandidates = [...lastGroup, ...lastButOneGroup];
        groups[groups.length - 2] = _.slice(lastCandidates, 0, lastGroupsSize);
        groups[groups.length - 1] = _.slice(lastCandidates, lastGroupsSize);
      }
    }

    const newGdGroups = [];
    const panelist1Snapshot = await db
      .collection('users')
      .doc(panelist1)
      .get();
    const panelist1Data = panelist1Snapshot.data();

    const panelist2Snapshot = await db
      .collection('users')
      .doc(panelist2)
      .get();
    const panelist2Data = panelist2Snapshot.data();

    for (const [groupIndex, group] of groups.entries()) {
      const groupDoc = db.collection('gdGroups').doc();
      // eslint-disable-next-line no-await-in-loop
      const groupDiscussionID = await generateGroupDiscussionID(jypCity);
      // eslint-disable-next-line no-await-in-loop
      await groupDoc.set({
        createdAt: moment().unix(),
        updatedAt: moment().unix(),
        id: groupDoc.id,
        groupDiscussionID,
        jypCity,
        candidates: group,
        panelist: groupIndex % 2 === 0 ? panelist1Data : panelist2Data,
        panel: groupIndex % 2 === 0 ? 'PANEL1' : 'PANEL2',
        completed: false,
      });
      // eslint-disable-next-line no-await-in-loop
      await Promise.all(
        group.map(candidate => db
          .collection('candidates')
          .doc(candidate)
          .update({
            groupDiscussionID,
          })),
      );
      newGdGroups.push(groupDoc.id);
    }

    return {
      success: true,
      data: {
        message: 'Groups created successfuly',
        groups: newGdGroups,
      },
    };
  }

  return {
    success: true,
    data: {
      message: 'Groups created successfuly',
      groups: [],
    },
  };
};



// WEBPACK FOOTER //
// ./src/services/groupDiscussionServices.js